export enum HttpResponseType {

    Blob = 'blob',
    Text = 'text',
    JSON = 'json',
    ArrayBuffer = 'arraybuffer',

}
